import { render, staticRenderFns } from "./domainManage.vue?vue&type=template&id=3c1c6baa&scoped=true&"
import script from "./domainManage.vue?vue&type=script&lang=js&"
export * from "./domainManage.vue?vue&type=script&lang=js&"
import style0 from "./domainManage.vue?vue&type=style&index=0&id=3c1c6baa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1c6baa",
  null
  
)

export default component.exports